/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Facet } from './facet';
import { IndexSearchResult } from './indexSearchResult';


export interface IndexSearchResponse { 
    /**
     * The total number of index search results that matched the search term query
     */
    totalIndexSearchResults?: number;
    /**
     * The top 200 index search results that matched the search term query
     */
    indexSearchResults?: Array<IndexSearchResult>;
    /**
     *                    Values that identifies a list of facet information.                
     */
    facets?: Array<Facet>;
}
